import './style.css';

import React from 'react';

class SystemNotification extends React.Component {
  render() {
    const { className, showTitle } = this.props;
    const containerClass = 'system-notification-container' + (className ? ' ' + className : '');

    const gridRowClass = !!showTitle ? 'sys-three-rows' : 'sys-two-rows';
    if (this.props.mobileFullscreen) {
      return (
        <div className={containerClass}>
          <div
            className={`system-notification system-notification-mobile-fullscreen ${gridRowClass}`}
          >
            {!!this.props.showTitle && <h1>{this.props.title}</h1>}
            <div className="system-notification-children">{this.props.children}</div>
            <div className="actions">{this.props.actions}</div>
          </div>
        </div>
      );
    }
    return (
      <div className={containerClass}>
        <div className={`system-notification ${gridRowClass}`}>
          {!!this.props.showTitle && <h1>{this.props.title}</h1>}
          <div className="system-notification-children">{this.props.children}</div>
          <div className="actions">{this.props.actions}</div>
        </div>
      </div>
    );
  }
}

SystemNotification.defaultProps = {
  title: 'System Notification',
  children: <div>Some content</div>,
  actions: '',
  mobileFullscreen: false,
  showTitle: true,
  className: ''
};

export default SystemNotification;

export const { defaultProps } = SystemNotification;
